import React, { useContext } from 'react';
import { Text, Box, Icon, Link, Button } from '@shopify/polaris';
import { SessionContext } from '#client/contexts/SessionContext';
import { hasPermission } from '#client/utils/helpers';

const Tile = ({ title, icon, links, description, button = [], requiredPermission }) => {
    const { currentUser } = useContext(SessionContext);
    if (typeof requiredPermission === 'string' && !hasPermission(currentUser, requiredPermission)) {
        return;
    }
    return (
        <Box padding="400" className="tile-box">
            {icon && (
                <Box className="tile-icon-wrapper">
                    <Icon source={icon} />
                </Box>
            )}

            <Text as="h2" variant="headingMd">
                {title}
            </Text>

            {Array.isArray(links) && links.length > 0 && (
                <Box marginBlockStart="300">
                    <Box gap="200" wrap>
                        {links.map((link, index) => (
                            <Link key={index} url={link.to} monochrome removeUnderline>
                                {link.label}
                            </Link>
                        ))}
                    </Box>
                </Box>
            )}

            {description && (
                <Text as="p" variant="bodyMd" tone="subdued">
                    {description}
                </Text>
            )}

            {button?.label && button?.onClick && (
                <Box className="dashboardButton">
                    <Button onClick={button.onClick} variant="primary">
                        {button.label}
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default Tile;
